import { sessionConstants } from '../constants';

export function natureIssueUpdate (state = {}, action) {
  switch (action.type) {
    case sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST:
        return {
          loading: true
         };
      case sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_SUCCESS:
      return {
          ...state,
          natureIssue: action.res,
          loading:false,
        };
      case sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_FAILURE:
        return {
          error: action.error,
          loading:false
        };
      default:
        return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/natureIssueUpdate.reducer.js